import { render, staticRenderFns } from "./IDSet.vue?vue&type=template&id=f0b26e60&"
import script from "./IDSet.vue?vue&type=script&lang=js&"
export * from "./IDSet.vue?vue&type=script&lang=js&"
import style0 from "./IDSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports